import React from 'react'

import Edit from 'components/WorkOrders/onboarding/edit'

const Install = props => {
  return <Edit {...props} />
}

export default Install
